export const cleanNumberMask = (input: string) => {
  return input.replace(/[^\d]/g, '')
}

export const getSocialMediaType = (url: string) => {
  const platformRegex =
    /(x\.com|tiktok\.com|linkedin\.com|facebook\.com|instagram\.com|twitter\.com|pinterest\.com)/

  const match = url.match(platformRegex)
  if (match) {
    const result = match[1].replace('.com', '')
    if (result === 'x') {
      return 'twitter'
    } else {
      return result
    }
  } else {
    return null
  }
}

export const getUsernameFromUrl = (url: string) => {
  // Twitter / X
  if (url.includes('twitter.com') || url.includes('x.com')) {
    const parts = url.split('/')
    return parts[parts.length - 1]
  }

  // Facebook
  if (url.includes('facebook.com')) {
    if (url.includes('profile.php?id=')) {
      const match = url.match(/profile\.php\?id=(\d+)/)
      if (match && match[1]) {
        return `Facebook Profile`
      }
    }

    if (url.includes('/p/')) {
      const match = url.match(/\/p\/([^/?]+)/)
      if (match && match[1]) {
        return match[1]
      }
    }

    const usernameStartIndex = url.indexOf('com/') + 4
    const usernameEndIndex = url.indexOf('/', usernameStartIndex)
    const username = url.substring(
      usernameStartIndex,
      usernameEndIndex !== -1 ? usernameEndIndex : undefined,
    )

    if (username.includes('?')) {
      return username.split('?')[0]
    }

    return username
  }

  // Instagram
  if (url.includes('instagram.com')) {
    const usernameStartIndex = url.indexOf('com/') + 4
    const usernameEndIndex = url.indexOf('/', usernameStartIndex)
    return url.substring(
      usernameStartIndex,
      usernameEndIndex !== -1 ? usernameEndIndex : undefined,
    )
  }

  // Reddit
  if (url.includes('reddit.com')) {
    const parts = url.split('/').filter((part) => part.trim() !== '')
    return parts[parts.length - 1]
  }

  // LinkedIn
  if (url.includes('linkedin.com')) {
    const usernameStartIndex = url.indexOf('in/') + 3
    const usernameEndIndex = url.indexOf('/', usernameStartIndex)
    return url.substring(
      usernameStartIndex,
      usernameEndIndex !== -1 ? usernameEndIndex : undefined,
    )
  }

  // Pinterest
  if (url.includes('pinterest.com')) {
    const parts = url.split('/')
    const username = parts[parts.length - 1] || parts[parts.length - 2]
    return username
  }

  // tiktok
  if (url.includes('tiktok.com')) {
    const parts = url.split('/')
    return parts[parts.length - 1]
  }

  // Default case
  return undefined
}

export const parseFullName = (fullname: string) => {
  const words = fullname.trim().split(/\s+/)
  const firstName = words[0]
  const lastName = words.length > 1 ? words[words.length - 1] : ''
  return { firstName, lastName }
}

export const textEllipsis = (text: string, maxLength: number) => {
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

export const stripHtmlTags = (html: string): string => {
  return html.replace(/<[^>]*>/g, '')
}
